
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action, State } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import vSelect from "vue-select"
import TextAreaToggleExpand from "@/components/Fields/TextAreaToggleExpand.vue"

import { CaseDetails, CaseField, CaseUser } from "@/types"

import api from "@/services/api"
const caseStore = namespace("cases")

	@Component({
		components: {
			"scrollbar": VuePerfectScrollbar,
			"text-area-expand": TextAreaToggleExpand
		}
	})
export default class PostComment extends Vue {
	@caseStore.Getter("getCurrentCase") public currentCase: any;

	@State tenantEnabledFeatures!: { [key: string]: boolean }

	private comment: string = "";

	public async postComment () {
		if (this.comment && this.comment.length > 0 && /\S/.test(this.comment)) {
			await api.postComment(this.currentCase.id, this.comment.trim(), null, !!this.tenantEnabledFeatures["richText"])
			this.comment = ""
		}
	}

	private get postCommentStyle (): any {
		return {
			transform: this.comment.length > 0 ? "translate(0, 0)" : "translate(50px, 0)"
		}
	}
	private get postCommentBoxStyle (): any {
		return {
			width: this.comment.length > 0 ? "46px" : "0",
			transition: "width 0.2s"
		}
	}
}
